import '../../assets/index43.css';var Q = Object.defineProperty, X = Object.defineProperties;
var Y = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var I = Object.prototype.hasOwnProperty, T = Object.prototype.propertyIsEnumerable;
var A = (o, e, a) => e in o ? Q(o, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : o[e] = a, t = (o, e) => {
  for (var a in e || (e = {}))
    I.call(e, a) && A(o, a, e[a]);
  if (v)
    for (var a of v(e))
      T.call(e, a) && A(o, a, e[a]);
  return o;
}, u = (o, e) => X(o, Y(e));
var k = (o, e) => {
  var a = {};
  for (var c in o)
    I.call(o, c) && e.indexOf(c) < 0 && (a[c] = o[c]);
  if (o != null && v)
    for (var c of v(o))
      e.indexOf(c) < 0 && T.call(o, c) && (a[c] = o[c]);
  return a;
};
import { jsx as n, jsxs as F } from "react/jsx-runtime";
import { forwardRef as Z } from "react";
import { CheckFarFAIcon as ee } from "../Icons/index.js";
import { c as f, e as oe, a as ae } from "../../get-size-Bc1Pz5yf.js";
import { c as ce } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as z, f as re, e as se, B as te } from "../../factory-ueRxoNOV.js";
import { u as ie } from "../../use-styles-DToiHEa6.js";
import { C as le } from "../../CheckIcon-DkmKiN6y.js";
import { c as ne } from "../../create-optional-context-CQ2ahjKQ.js";
import { u as j } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as pe } from "../../use-id-D2tGiO9x.js";
const [de, he] = ne(), ue = {};
function w(o) {
  const { value: e, defaultValue: a, onChange: c, multiple: s, children: i } = z(
    "ChipGroup",
    ue,
    o
  ), [r, l] = j({
    value: e,
    defaultValue: a,
    finalValue: s ? [] : null,
    onChange: c
  });
  return /* @__PURE__ */ n(de, { value: { isChipSelected: (p) => Array.isArray(r) ? r.includes(p) : p === r, onChange: (p) => {
    const d = p.currentTarget.value;
    Array.isArray(r) ? l(r.includes(d) ? r.filter((h) => h !== d) : [...r, d]) : l(d);
  }, multiple: s }, children: i });
}
w.displayName = "@mantine/core/ChipGroup";
var B = { root: "m_f59ffda3", label: "m_be049a53", "label--outline": "m_3904c1af", "label--filled": "m_fa109255", "label--light": "m_f7e165c3", iconWrapper: "m_9ac86df9", checkIcon: "m_d6d72580", input: "m_bde07329" };
const me = {
  type: "checkbox"
}, fe = ce(
  (o, { size: e, radius: a, variant: c, color: s, autoContrast: i }) => {
    const r = o.variantColorResolver({
      color: s || o.primaryColor,
      theme: o,
      variant: c || "filled",
      autoContrast: i
    });
    return {
      root: {
        "--chip-fz": ae(e),
        "--chip-size": f(e, "chip-size"),
        "--chip-radius": a === void 0 ? void 0 : oe(a),
        "--chip-checked-padding": f(e, "chip-checked-padding"),
        "--chip-padding": f(e, "chip-padding"),
        "--chip-icon-size": f(e, "chip-icon-size"),
        "--chip-bg": s || c ? r.background : void 0,
        "--chip-hover": s || c ? r.hover : void 0,
        "--chip-color": s || c ? r.color : void 0,
        "--chip-bd": s || c ? r.border : void 0,
        "--chip-spacing": f(e, "chip-spacing")
      }
    };
  }
), y = re((o, e) => {
  const a = z("Chip", me, o), R = a, {
    classNames: c,
    className: s,
    style: i,
    styles: r,
    unstyled: l,
    vars: x,
    id: _,
    checked: p,
    defaultChecked: d,
    onChange: h,
    value: S,
    wrapperProps: W,
    type: $,
    disabled: P,
    children: O,
    size: U,
    variant: V,
    icon: q,
    rootRef: D,
    autoContrast: ve,
    mod: E
  } = R, H = k(R, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "id",
    "checked",
    "defaultChecked",
    "onChange",
    "value",
    "wrapperProps",
    "type",
    "disabled",
    "children",
    "size",
    "variant",
    "icon",
    "rootRef",
    "autoContrast",
    "mod"
  ]), m = ie({
    name: "Chip",
    classes: B,
    props: a,
    className: s,
    style: i,
    classNames: c,
    styles: r,
    unstyled: l,
    vars: x,
    varsResolver: fe
  }), C = he(), G = pe(_), { styleProps: J, rest: K } = se(H), [L, M] = j({
    value: p,
    defaultValue: d,
    finalValue: !1,
    onChange: h
  }), N = C ? {
    checked: C.isChipSelected(S),
    onChange: (g) => {
      C.onChange(g), h == null || h(g.currentTarget.checked);
    },
    type: C.multiple ? "checkbox" : "radio"
  } : {}, b = N.checked || L;
  return /* @__PURE__ */ F(
    te,
    u(t(t(t({
      size: U,
      variant: V,
      ref: D,
      mod: E
    }, m("root")), J), W), {
      children: [
        /* @__PURE__ */ n(
          "input",
          t(t(u(t({
            type: $
          }, m("input")), {
            checked: b,
            onChange: (g) => M(g.currentTarget.checked),
            id: G,
            disabled: P,
            ref: e,
            value: S
          }), N), K)
        ),
        /* @__PURE__ */ F(
          "label",
          u(t({
            htmlFor: G,
            "data-checked": b || void 0,
            "data-disabled": P || void 0
          }, m("label", { variant: V || "filled" })), {
            children: [
              b && /* @__PURE__ */ n("span", u(t({}, m("iconWrapper")), { children: q || /* @__PURE__ */ n(le, t({}, m("checkIcon"))) })),
              /* @__PURE__ */ n("span", { children: O })
            ]
          })
        )
      ]
    })
  );
});
y.classes = B;
y.displayName = "@mantine/core/Chip";
y.Group = w;
const Ce = {}, ge = Z((r, i) => {
  var l = r, {
    className: o,
    size: e = "md",
    disabled: a,
    children: c
  } = l, s = k(l, [
    "className",
    "size",
    "disabled",
    "children"
  ]);
  return /* @__PURE__ */ n(
    y,
    u(t({
      ref: i,
      classNames: Ce,
      size: e,
      variant: "filled",
      disabled: a,
      icon: /* @__PURE__ */ n(ee, {}),
      className: o
    }, s), {
      children: c
    })
  );
});
ge.displayName = "SelectableTag";
export {
  ge as SelectableTag
};
